<template>
    <layout :title="_product.name">
        <div id="primary" class="content-area">
            <main id="main" class="site-main">
                <div class="cont maincont">
                    <ul class="b-crumbs">
                        <li><inertia-link href="/">Inicio</inertia-link></li>
                        <li><inertia-link href="/productos">Productos</inertia-link></li>
                        <li>{{ _product.name }}</li>
                    </ul>

                    <article>
                        <div class="prod">
                            <div v-if="_product.images && _product.images.length" class="prod-slider-wrap prod-slider-shown">

                                <div class="flexslider prod-slider" id="prod-slider">
                                    <ul class="slides">
                                        <li v-for="image in _product.images" :key="image">
                                            <a data-fancybox-group="prod" class="fancy-img" :href="`/storage/${image}`">
                                                <img :src="`/storage/${image}`" alt="" width="550" height="490">
                                            </a>
                                        </li>
                                    </ul>
                                    <div class="prod-slider-count"><p><span class="count-cur">1</span> / <span class="count-all">{{ _product.images.length }}</span></p><p class="hover-label prod-slider-zoom"><i class="icon ion-search"></i><span>Zoom In</span></p></div>
                                </div>
                                <div class="flexslider prod-thumbs" id="prod-thumbs">
                                    <ul class="slides">
                                        <li v-for="image in _product.images" :key="image">
                                            <img :src="`/storage/${image}`" alt="">
                                        </li>
                                    </ul>
                                </div>

                            </div>

                            <div class="prod-cont">
                                <!-- <div class="prod-rating-wrap">
                                    <p data-rating="4" class="prod-rating">
                                        <i class="rating-ico" title="1"></i><i class="rating-ico" title="2"></i><i class="rating-ico" title="3"></i><i class="rating-ico" title="4"></i><i class="rating-ico" title="5"></i>
                                    </p>
                                    <p class="prod-rating-count">7</p>
                                </div> -->

                                <p v-if="_product.category" class="prod-categs"><a href="#">{{ _product.category.name }}</a></p>
                                <h1>{{ _product.name }}</h1>
                                <div class="variations_form cart">
                                    <p class="prod-price">${{ _product.price }}</p>
                                    <p class="prod-excerpt text-gray-900">{{ _product.description }}</p>
                                    <div class="prod-add">
                                        <!-- <div class="variations">
                                            <div class="variations-row">
                                                <div class="label"><label >Сolor</label></div>
                                                <div class="value">
                                                    <select>
                                                        <option value="">Choose an option</option>
                                                        <option value="blue">Blue</option>
                                                        <option value="green">Green</option>
                                                        <option value="yellow">Yellow</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div> -->
                                        <add-to-cart :product="_product"></add-to-cart>
                                        <!-- <div class="prod-li-favorites">
                                            <a href="wishlist.html" class="hover-label add_to_wishlist"><i class="icon ion-heart"></i><span>Add to Wishlist</span></a>
                                        </div>
                                        <p class="prod-li-compare">
                                            <a href="compare.html" class="hover-label prod-li-compare-btn"><span>Compare</span><i class="icon ion-arrow-swap"></i></a>
                                        </p> -->
                                    </div>
                                </div>
                                <!-- <div class="prod-props">
                                    <dl class="product_meta">
                                        <dt>SKU:</dt>
                                        <dd>2135687</dd>
                                        <dt>Brand:</dt>
                                        <dd><a href="#">BMP</a></dd>
                                        <dt>Weight</dt>
                                        <dd>1 kg</dd>
                                        <dt>Dimensions</dt>
                                        <dd>4 x 50 cm</dd>
                                        <dt>Сolor</dt>
                                        <dd>Blue, Green</dd>
                                        <dt>Manufacturer</dt>
                                        <dd>Germany</dd>
                                        <dt>Material</dt>
                                        <dd>Metal, Plastic</dd>
                                    </dl>
                                </div> -->
                            </div>
                            <p class="prod-badge">
                                <!-- <span class="badge-1">TOP SELLER</span> -->
                            </p>
                        </div>
                    </article>
                </div>
            </main>
        </div>
    </layout>
</template>

<script>
import Layout from '../Layout';
import AddToCart from '../../components/Cart/AddToCart'

export default {
    props: {
        _product: Object,
    },
    components: {
        Layout,
        AddToCart,
    },

}
</script>

<style>

</style>
